import { useSelector } from 'react-redux'
import { StyledFooter } from './Footer.style'
import { getFooter } from 'src/selectors/settings'
import RichText from 'src/components/atoms/RichText/RichText'
import Logo from 'src/components/atoms/Logo/Logo'
import FlexWrapper from 'src/components/_layout/FlexWrapper/FlexWrapper'

const Footer: React.VFC = () => {
    const { footer1, footer2, footer3 } = useSelector(getFooter)
    const footer = [footer1, footer2, footer3]
    return (
        <StyledFooter>
            <FlexWrapper
                justify={{ '@initial': 'start', '@md': 'between' }}
                direction={{ '@initial': 'column', '@lg': 'row' }}
            >
                <div>
                    <Logo
                        css={{
                            width: '120px',
                            marginBottom: '$sm',
                            '@lg': {
                                width: 'calc(2 * $colWidth)',
                                marginBottom: 0,
                            },
                        }}
                    />
                </div>
                {footer.map((item, index) => (
                    <RichText
                        key={index}
                        htmlString={item}
                        textVariant="small2"
                    />
                ))}
            </FlexWrapper>
        </StyledFooter>
    )
}
export default Footer
